module.exports = __webpack_public_path__ + "img/Character_Dainsleif_Thumb.75f34a6a.png";